import { defineComarkPlugin } from '@comark/nuxt/parse'
import { textContent } from '@comark/nuxt/utils'

// Like MDC: fill `title` (first h1) and `description` (first paragraph) when not defined in the frontmatter
export default defineComarkPlugin(() => ({
  name: 'auto-frontmatter',
  post(state) {
    const { frontmatter, nodes } = state.tree

    if (!frontmatter.title) {
      const heading = nodes.find(node => Array.isArray(node) && node[0] === 'h1')
      if (heading) frontmatter.title = textContent(heading).trim()
    }

    if (!frontmatter.description) {
      const paragraph = nodes.find(node => Array.isArray(node) && node[0] === 'p')
      if (paragraph) frontmatter.description = textContent(paragraph).trim()
    }
  },
}))
